import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { api } from "@/lib/api";

export function useApi() {
  const { getToken, isSignedIn } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = isSignedIn ? await getToken() : null;
      const headers = { ...(config.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) };
      const res = await api.request({ method, url, data, ...config, headers });
      return res.data;
    },
    [getToken, isSignedIn]
  );
}
